<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-card flat class="pa-0">
          <v-card-title class="title">
            {{ restaurantName }}
          </v-card-title>
          <v-card-subtitle>{{
            $t("demo.tableNr", { tabNr: "14" })
          }}</v-card-subtitle>
          <v-divider></v-divider>
          <template v-if="showPaymentSucces">
            <v-alert :timeout="3000" :value="true" type="success">
              {{ $t("demo.paymentSuccesful") }}
            </v-alert>
            <v-divider></v-divider>
          </template>
          <template v-if="showPaymentFailed">
            <v-alert :timeout="3000" :value="true" type="error">
              {{ $t("demo.paymentFailed") }}
            </v-alert>
            <v-divider></v-divider>
          </template>
          <v-list dense>
            <v-list-item v-for="item in items" :key="item.name">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.amount }}x&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action-text>{{
                item.price.toFixed(2) | currency("USD", true, 2)
              }}</v-list-item-action-text>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t("demo.subtotal") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action-text>{{
                subtotal.toFixed(2) | currency("USD", true, 2)
              }}</v-list-item-action-text>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("demo.taxPercent", { perc: 20 })
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action-text>{{
                tax.toFixed(2) | currency("USD", true, 2)
              }}</v-list-item-action-text>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  ><strong>{{ $t("demo.total") }}</strong></v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-action-text
                ><strong>{{
                  total.toFixed(2) | currency("USD", true, 2)
                }}</strong></v-list-item-action-text
              >
            </v-list-item>
            <hr />
            <hr />
          </v-list>
          <v-btn
            class="mb-2"
            v-if="
              !$route.query['payment-success'] ||
              $route.query['payment-success'] === 'false'
            "
            color="primary"
            block
            @click="payAndCheckinDialog = true"
          >
            {{ $t("demo.payNow") }}
          </v-btn>
          <v-btn
            :disabled="
              !$route.query['payment-success'] ||
              $route.query['payment-success'] !== 'true'
            "
            color="success"
            block
            @click="generatePDF"
          >
            {{ $t("demo.downloadBill") }}
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="payAndCheckinDialog" max-width="360">
      <v-card>
        <v-card-title>{{ $t("demo.choosePaymentOption") }}</v-card-title>
        <v-list>
          <v-list-item disabled>
            <v-list-item-avatar>
              <img src="@/assets/logos/cc_no_bg.png" alt="Credit Card logo" />
            </v-list-item-avatar>
            <v-list-item-title>{{ $t("demo.creditCard") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="payAndCheckin">
            <v-list-item-avatar height="20" width="40">
              <img
                src="@/assets/logos/Sonio/sonio_pay_logo_no_bg.png"
                alt="Sonio Pay"
              />
            </v-list-item-avatar>
            <v-list-item-title>{{ $t("demo.sonioPay") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import QRCode from "qrcode";

export default {
  data() {
    return {
      restaurantName: "Luxury Hotel Restaurant Demo",
      items: [
        {
          amount: 1,
          name: "Salad",
          price: 12.99,
        },
        {
          amount: 2,
          name: "Soup of the Day",
          price: 8.99,
        },
        {
          amount: 2,
          name: "Bread and Butter",
          price: 4.99,
        },
        {
          amount: 1,
          name: "Seafood Platter",
          price: 59.99,
        },
        {
          amount: 1,
          name: "Cheese Plate",
          price: 19.99,
        },
        {
          amount: 3,
          name: "Coffee or Tea",
          price: 3.99,
        },
        {
          amount: 1,
          name: "Lobster",
          price: 49.99,
        },
        {
          amount: 5,
          name: "Wine",
          price: 29.99,
        },
        {
          amount: 2,
          name: "Dessert",
          price: 9.99,
        },
      ],
      payAndCheckinDialog: false,
      showPaymentSucces: false,
      showPaymentFailed: false,
    };
  },
  filters: {
    currency(
      value,
      symbol = "$",
      thousandSeparator = ",",
      fractionCount = 2,
      fractionSeparator = "."
    ) {
      const result = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: symbol,
        minimumFractionDigits: fractionCount,
        maximumFractionDigits: fractionCount,
        useGrouping: true,
        groupingSeparator: thousandSeparator,
        decimalSeparator: fractionSeparator,
      }).format(value);
      return result;
    },
  },
  mounted() {
    this.checkPaymentStatus();
    // this.generateDemoPDF();
  },
  computed: {
    subtotal() {
      return this.items.reduce(
        (acc, item) => acc + item.price * item.amount,
        0
      );
    },
    tax() {
      return this.subtotal * 0.2;
    },
    total() {
      return this.subtotal + this.tax;
    },
    color() {
      return this.$store.state.theme.theme.primary;
    },
    backgroundImage() {
      return this.$store.state.theme.theme.appBackgroundImage;
    },
  },
  watch: {
    "$route.query"(val) {
      this.checkPaymentStatus();
    },
  },
  methods: {
    payAndCheckin() {
      location.href = encodeURI(
        `https://api.test.sonio-poc.advanced-living.vipaso.cloud/payment?amount=${this.total.toFixed(
          2
        )}&return-url=${location.href + "&payment-success={payment-success}"}`
      );
    },
    checkPaymentStatus() {
      if (this.$route.query && this.$route.query["payment-success"]) {
        if (this.$route.query["payment-success"] === "true") {
          this.showPaymentSucces = true;
          this.showPaymentFailed = false;
        } else if (this.$route.query["payment-success"] === "false") {
          this.showPaymentFailed = true;
          this.showPaymentSucces = false;
        }
      }
    },
    generatePDF() {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      doc.setFillColor(this.color);
      doc.rect(10, 10, 190, 10, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(22);
      doc.text(this.restaurantName, 12, 18);
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(18);
      doc.text("Bill", 10, 35);
      doc.setLineWidth(0.5);
      doc.line(10, 37, 200, 37);
      doc.setFontSize(12);
      let y = 50;
      this.items.forEach((item) => {
        doc.text(`${item.amount}x    ${item.name}`, 10, y);
        doc.text(
          `${this.$options.filters.currency(item.price, "USD", true, 2)}`,
          170,
          y
        );
        y += 5;
      });
      doc.setLineWidth(0.5);
      doc.line(10, y + 2, 200, y + 2);
      y += 10;
      doc.text(
        `${this.$t("demo.subtotal")}: ${this.$options.filters.currency(
          this.subtotal,
          "USD",
          true,
          2
        )}`,
        10,
        y
      );
      doc.text(
        `${this.$t("demo.taxPercent", {
          perc: 20,
        })}: ${this.$options.filters.currency(
          this.subtotal * 0.2,
          "USD",
          true,
          2
        )}`,
        130,
        y
      );
      y += 5;
      doc.setLineWidth(0.5);
      doc.line(10, y + 2, 200, y + 2);
      y += 10;
      doc.text(
        `${this.$t("demo.total")}: ${this.$options.filters.currency(
          this.subtotal + this.tax,
          "USD",
          true,
          2
        )}`,
        10,
        y
      );
      let currentDate = new Date();
      let formattedDate =
        currentDate.getFullYear() +
        "-" +
        (currentDate.getMonth() + 1) +
        "-" +
        currentDate.getDate();
      doc.save(formattedDate + `_${this.restaurantName}.pdf`);
    },
    // use this in mounted e.g., only if you want to generate the PDF to use it in demo
    async generateDemoPDF() {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const qrCodeWidth = 90;

      // Generate QR code from the link
      const qrCode = await QRCode.toDataURL(
        "https://demo06.onesquare.tv/ONEapp/#/demo/fetch-my-bill?mode=demo&property=5bb38b851325f20001ea7bf1&theme=5c701715c6948300019dc1fc&skin=5&country=United%20Arab%20Emirates&city=Dubai&iso=AT&email=tothpinceszet%40gmail.com&name=Toth&room=1042&lang=de"
      );

      // Add QR code image to the PDF
      doc.addImage(
        qrCode,
        "PNG",
        pageWidth / 2 - 45,
        pageHeight / 2 - 45,
        qrCodeWidth,
        qrCodeWidth
      );

      // Set font size and add "Pay now" text
      doc.setFontSize(qrCodeWidth / 2);
      doc.text("Pay now", pageWidth / 2, pageHeight / 2 - 65, "center");

      // Set font size and add "Table nr. 14" text
      doc.setFontSize(qrCodeWidth / 3);
      doc.text("Table nr. 14", pageWidth / 2, pageHeight / 2 + 55, "center");

      // Save the PDF with the current date in the file name
      doc.save("qr_code_table_14_concierge_service_demo.pdf");
    },
  },
};
</script>
